module.exports = __webpack_public_path__ + "img/grid-3x2-gap.bb2110d2.svg";